// extracted by mini-css-extract-plugin
export default {"selected_filters":"Filters_selected_filters__dWfkv","selected_item":"Filters_selected_item__f99Of","remove-button":"Filters_remove-button__yiNqU"};